import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/reward-system/reward-system.css";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import { selectUser } from "../../components/auth/auth.selector";
import CoinSpent from "./coin-spent/CoinSpent";
import CoinsEarnedVsSpentChart from "./CoinsEarnedVsSpentChart";
import TotalBalanceLeft from "./TotalBalanceLeft";
import TopGyms from "./top-gyms/TopGyms";
import GymFilter from "../../components/common-components/filters/gym-filter";
// import DateRangerFilter from "../../components/common-components/filters/date-ranger-filter";
import AllEarningTask from "./earning-task/AllEarningTask";
import TopUsers from "./top-users/TopUsers";
import {
  setSelectedGym,
  setStartAndEndDate,
} from "../../redux/reducers/filtersSlice";

const RewardSystem = () => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();
  const selectedGym = useSelector((state) => state.filters.selectedGym);
  // const startAndEndDate = useSelector((state) => state.filters.startAndEndDate);

  // const [isPage, setIsPage] = useState(0);
  // const [pageLimit, setPageLimit] = useState(10);
  // const iniAllFilter = {
  //   isActive: "",
  //   searchString: "",
  //   startDate: startAndEndDate?.startDate || "",
  //   endDate: startAndEndDate?.endDate || "",
  //   gym: selectedGym?.value || "",
  // };
  // const [allFilters, setAllFilters] = useState(iniAllFilter);
  // const iniFilters = {
  //   page: isPage + 1,
  //   limit: pageLimit || 10,
  //   startDate: startAndEndDate?.startDate || "",
  //   endDate: startAndEndDate?.endDate || "",
  //   gym: selectedGym?.value || "",
  // };
  // const [filters, setFilters] = useState(iniFilters);

  // useEffect(() => {
  //   setFilters((prevs) => ({
  //     ...prevs,
  //     page: isPage + 1,
  //     limit: pageLimit || 10,
  //     gym: selectedGym?.value || "",
  //     startDate: startAndEndDate?.startDate || "",
  //     endDate: startAndEndDate?.endDate || "",
  //   }));
  // }, [isPage, pageLimit, selectedGym, startAndEndDate]);

  // const handleDateChange = (startDate, endDate) => {
  //   dispatch(setStartAndEndDate({ startDate, endDate }));
  //   setAllFilters((prev) => ({
  //     ...prev,
  //     startDate,
  //     endDate,
  //   }));
  //   setFilters((prev) => ({
  //     ...prev,
  //     startDate,
  //     endDate,
  //   }));
  // };

  return (
    <HelmetWrapper title="WTF: Reward System">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <div className="reward__System">
          <div className="reward__System__structured">
            <CommonStructured
              pageHeading={"Reward System"}
              // isReload={() => getExpenseCategories(filters)}
            />
          </div>

          <div className="reward__System__filters">
            <div className="reward__System__filters__inner">
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                }}
              >
                <GymFilter
                  selectedGym={selectedGym}
                  setSelectedGym={(value) => {
                    dispatch(setSelectedGym(value));
                    // setAllFilters({ ...allFilters, gym: value });
                  }}
                />
              </div>
              {/* <DateRangerFilter
                startDate={startAndEndDate?.startDate}
                endDate={startAndEndDate?.endDate}
                onDateChange={handleDateChange}
              /> */}
            </div>
          </div>
        </div>

        <TotalBalanceLeft userInfoData={userInfoData} />

        <CoinSpent userInfoData={userInfoData} gymId={selectedGym?.value} />

        <CoinsEarnedVsSpentChart
          userInfoData={userInfoData}
          gymId={selectedGym?.value}
        />

        <TopUsers userInfoData={userInfoData} gymId={selectedGym?.value} />
        <TopGyms userInfoData={userInfoData} gymId={selectedGym?.value} />
        <AllEarningTask userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default RewardSystem;
